import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Navigation from './navigation/Navigation';
import { AuthProvider } from './providers/AuthProvider';
import GlobalStyle from './assets/styles/GlobalStyle';
import { GlobalDataProvider } from './providers/GlobalDataProvider';
import { PopupProvider } from './providers/PopupProvider';

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <GlobalDataProvider>
            <PopupProvider>
              <Navigation />
            </PopupProvider>
          </GlobalDataProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
